import { FC } from 'react';

import * as Styles from './fielzone-modal.styles';

const FieldzoneModal: FC = () => {

  const handleFielTorcedorClick = () => {
    window.open('https://www.fieltorcedor.com.br', '_blank');
  };

  return (
    <Styles.Body>
      <Styles.Title>
        ⚽ Confirmação de Compra – Camarote Fielzone
      </Styles.Title>

      <Styles.ImportantSection>
        <Styles.ImportantItem>
          <Styles.ImportantText>
            🏦 Para acessar o Camarote Fielzone, o cadastro facial é obrigatório para todos os torcedores,
            incluindo dependentes do Fiel Torcedor e crianças na categoria até 11 anos, devem ter seu próprio
            cadastro individual.
          </Styles.ImportantText>
        </Styles.ImportantItem>

        <Styles.ImportantItem>
          <Styles.ImportantText>
            👥 <strong>Comprou vários ingressos?</strong> Transfira para seus convidados via Ingresse e peça
            que cada um faça seu cadastro facial.
          </Styles.ImportantText>
        </Styles.ImportantItem>

        <Styles.ImportantItem>
          <Styles.ImportantText>
            🟥 Sem a biometria facial, o acesso será negado.
          </Styles.ImportantText>
        </Styles.ImportantItem>
      </Styles.ImportantSection>

      <Styles.WarningFooter>
        <Styles.WarningIcon>🟨</Styles.WarningIcon>
        Faça seu cadastro o quanto antes para evitar filas e aproveitar o jogo!
      </Styles.WarningFooter>

      <Styles.ButtonSection>
        <Styles.FielTorcedorButton onClick={handleFielTorcedorClick}>
          ➡️ CADASTRAR FACIAL NO SITE FIEL TORCEDOR AGORA!
        </Styles.FielTorcedorButton>
      </Styles.ButtonSection>
    </Styles.Body>
  );
};

export default FieldzoneModal;
